<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="head-confirm-modal-list">
      <h2>Você confirma o encaminhamento deste paciente?</h2>
    </div>
    <div class="footer-confirm-modal-list">
      <button mat-flat-button color="primary" class="btn-block" (click)="clickConfirm()">
        @if (isLoading == false) {
          <span>Encaminhar</span>
        }
        @if (isLoading == true) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
      </button>
      <button mat-flat-button color="accent" class="btn-block"(click)="clickCancel()">Cancelar</button>
    </div>
  </div>
</div>
